import React from 'react';
import { DisclosureButton, Menu, MenuButton, MenuItem, MenuItems, Transition } from '@headlessui/react';
import Utilities from '@util/Utilities';
import useSiteState from '@app/state/SiteState';
import { Link, useNavigate } from 'react-router-dom';
import Avatar from '@app/component/avatar/Avatar';
import SecurityService from '@app/model/_security/service/SecurityService';
import { useTranslation } from '@app/component/translation/Translation';
import useToaster from '@app/component/overlays/toaster/ToasterHook';


const UserMenuItemFragment: React.FunctionComponent<{ isMobile?: boolean }> = ({ isMobile = false }) => {

	const [principal, logout] = useSiteState(state => [state.principal, state.logout]);
	const { t } = useTranslation();
	const toaster = useToaster();
	const navigate = useNavigate();

	const signOut = () => {
		SecurityService.signOut()
			.then(() => {
				logout();
				navigate('/sign-in', { replace: true });
			})
			.catch((error: any) => toaster.error('Sign Out', t(error.message)));
	};

	const userNavigation: { name: string, click?: () => void, href?: string }[] = [];

	userNavigation.push({ name: 'Account Settings', href: '/secured/settings/general' });
	userNavigation.push({ name: 'Sign out', click: signOut });

	return isMobile ? <div className="mt-3 space-y-1 px-2">
		{userNavigation.map((item) => (
			<DisclosureButton
				key={item.name}
				as="a"
				href={item.href}
				className="block rounded-md px-3 py-2 text-base font-medium text-gray-500 hover:bg-gray-100 hover:text-gray-800"
			>
				{item.name}
			</DisclosureButton>
		))}
	</div> : <Menu as="div" className="relative ml-3">
		<div>
			<MenuButton
				className="relative flex max-w-xs items-center rounded-full bg-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
				<span className="sr-only">Open user menu</span>
				<Avatar principal={principal!} isSmall />
			</MenuButton>
		</div>
		<Transition
			as={React.Fragment}
			enter="transition ease-out duration-100"
			enterFrom="transform opacity-0 scale-95"
			enterTo="transform opacity-100 scale-100"
			leave="transition ease-in duration-75"
			leaveFrom="transform opacity-100 scale-100"
			leaveTo="transform opacity-0 scale-95"
		>
			<MenuItems
				className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
				{userNavigation.map((item) => (
					<MenuItem key={item.name}>
						{({ focus }) => (
							<Link
								to={item.href ? item.href : ''}
								onClick={item.click ? item.click : undefined}
								className={Utilities.classNames(
									focus ? 'bg-slate-100' : '',
									'block px-4 py-2 text-sm text-slate-700 cursor-pointer',
								)}
							>
								{item.name}
							</Link>
						)}
					</MenuItem>
				))}
			</MenuItems>
		</Transition>
	</Menu>;
};

export default UserMenuItemFragment;